export const CALL_AI_REQUIRED_ROLES = [
  '_defaultcallai.role.admin',
  '_defaultcallai.role.listener',
  '_defaultcallai.role.recorder',
];

export const SYNC_ENABLED_USER = 'user_sync_enabled';
export const USE_MT_AUTH = 'use_mt_auth';
export const USE_CALLAI_MF = 'embed_call_mf_in_ls';
export const SHARING_WORKFLOW_ENABLE = 'sharing_workflow_enable';

export const CALLAI_PERMISSION = 'VIEW_CALL_RECORDINGS';
